import { createColumnHelper } from '@tanstack/react-table';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, StandaloneTable as Table, useTableState } from '@optimus-web/core';
import { DocumentTypeOptions } from './DocumentTypeOptions';
import { VisibilityAction } from './VisibilityAction';
import { DocumentsTableDataItem } from './types';

interface DocumentsTableProps {
    data: DocumentsTableDataItem[];
}

const columnHelper = createColumnHelper<DocumentsTableDataItem>();

const columns = [
    columnHelper.accessor('type', {
        header: () => <LocalizedText textKey={TextKey.CheckInFieldDocumentTypeColumnHeader} />,
        cell: DocumentTypeOptions,
        enableSorting: false,
        meta: { width: 360 },
    }),
    columnHelper.accessor('visibility.reservationOwner', {
        header: () => <LocalizedText textKey={TextKey.CheckInFieldVisibilityColumnHeader} />,
        cell: VisibilityAction,
        enableSorting: false,
        meta: { width: 180 },
    }),
    columnHelper.display({
        id: 'placeholder',
        enableSorting: false,
    }),
];

export const DocumentsTable = ({ data }: DocumentsTableProps) => {
    const [tableState, setTableState] = useTableState<DocumentsTableDataItem>({
        pagination: { show: false },
    });

    return (
        <Stack vertical spacing="200">
            <Table
                amountOfRows={data.length}
                columns={columns}
                data={data}
                onStateChange={setTableState}
                state={tableState}
                uniqueRowId="type"
            />
        </Stack>
    );
};
